import api from '../api';
import { fromDatetimeLocal } from '../constants/interview';

export async function submitInterviewRound(id, payload) {
  const body = {
    action: payload.action,
    feedback: payload.feedback,
    rejectionReasonCode: payload.rejectionReasonCode,
    rejectionComment: payload.rejectionComment
  };
  if (payload.interviewSchedule) {
    body.interviewSchedule = {
      ...payload.interviewSchedule,
      scheduledAt: fromDatetimeLocal(
        payload.interviewSchedule.scheduledAtLocal || payload.interviewSchedule.scheduledAt
      ),
      instructions:
        payload.interviewSchedule.instructions?.trim() || payload.note || ''
    };
  }
  return api.post(`/applications/${id}/interview-round`, body).then(r => r.data);
}
